<template>
  <div>
    <a-divider orientation="left">
      APPROVAL
    </a-divider>
    <a-card>
      <a-list>
        <ListItemApproval
          :workLeaveApproval="findLastIndexApproval(1)"
          department="Department Manager / Giám đốc - Trưởng bộ phận"
          :step="1"
          :openDrawer="() => (visible = true)"
          :currentApprovalStep="workLeave.currentApprovalStep"
          :status="workLeave.status"
        />
        <!-- <ListItemApproval
          :workLeaveApproval="findLastIndexApproval(2)"
          department="Phòng NS-PL"
          :step="2"
          :openDrawer="() => (visible = true)"
          :currentApprovalStep="workLeave.currentApprovalStep"
          :status="workLeave.status"
        /> -->
      </a-list>
    </a-card>
  </div>
</template>
<script>
import query from "../../constant/query";
import ListItemApproval from "./components/listItemApproval";
export default {
  components: { ListItemApproval },
  props: {
    workLeave: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
      loadingBtn: false,
      note: "",
      visibleHistory: false,
    };
  },
  methods: {
    approvalWorkLeave(approvalStatus) {
      const { idWorkLeave } = this.$route.params;
      if (!idWorkLeave) {
        throw new Error("Cannot get id work leave from params");
      }
      this.loadingBtn = true;
      this.$apollo
        .mutate({
          mutation: query.approvalWorkLeave,
          variables: {
            id: idWorkLeave,
            approvalStatus,
            note: this.note,
          },
        })
        .then(({ errors }) => {
          this.loadingBtn = false;
          this.$notification.success({
            message: "Thông báo",
            description: "Phê duyệt phiếu nghỉ phép thành công!",
          });
          this.$router.push({ name: "Danh sách nghỉ phép" });
        })
        .catch((err) => {
          this.loadingBtn = false;
          this.$notification.error({
            message: "Thông báo",
            description: "Lỗi không phê duyệt được phiếu nghỉ phép!",
          });
          console.error("Lỗi không phê duyệt được phiếu nghỉ phép!", err);
        });
    },
    onApproved() {
      this.approvalWorkLeave("APPROVED");
    },
    onRejected() {
      this.approvalWorkLeave("REJECTED");
    },
    onEditting() {
      this.approvalWorkLeave("EDITING");
    },
    findLastIndexApproval(step) {
      if (this.workLeave?.workLeaveApprovals?.length > 0 && step) {
        const array = [...this.workLeave.workLeaveApprovals];
        array.reverse();
        return array.find((e) => e.approvalStep === step) || {};
      }
      return {};
    },
  },
};
</script>
<style lang="css" scoped></style>
